const ErrorComponent = ({ msg ="Failed to load!" }) => {
  return (
    <p className="m-0">{msg}</p>
  )
}

export default ErrorComponent;